import { Link } from "gatsby";
import React from "react"
import { NowPlaying } from "../now-playing/now-playing"

export class Header extends React.Component {
  constructor () {
    super();
    this.state = { open: false }
  }

  toggle = () => {
    this.setState({ open: !this.state.open });
  }

  search = (e) => {
    e.preventDefault();
    this.props.onSearch && this.props.onSearch();
  }

  componentDidMount () {
    let links = document.querySelectorAll('.header__mobile a');
    console.log('Links');
    console.log(links);
    Array.from(links).forEach(link => {
      console.log(link);
      link.addEventListener('click', () => this.setState({ open: false }));
    });
  }

  render () {
    return (
      <header className={this.state.open ? 'header--open' : 'header--closed'}>
        { this.renderHeaderTop () }
        { this.renderHeaderContent () }
        { this.renderNowPlaying () }
        { this.renderMobileNav() }
      </header>
    )
  }

  renderHeaderTop = () => (
    <div className="header__top">
      <div className="header__top__left">
        <Link to="/"><img className="header__logo" src="/images/logo.svg" alt="Kiosk Radio" /></Link>
      </div>
      <div className="header__top__right">
        { /*  <Link to="/about">About</Link> */ }
        <a href="/shop" target="_blank">Shop</a>
        <a href="#search" onClick={this.search}><img src="/images/search.svg" className="header__search" />Search</a>
        { this.renderSocial() }
      </div>
      <div className="header__top__hamburger" onClick={this.toggle}>
        <span />
        <span />
        <span />
      </div>
    </div>
  )

  renderHeaderContent = () => (
    <div className="header__content">
      <Link to="/programme">Programme</Link>
      <Link to="/insiders">Insiders</Link>
      <Link to="/outsiders">Outsiders</Link>
      <Link to="/kiosk-tv">Kiosk TV</Link>
    </div>
  )

  renderSocial = () => (
    <div className="social">
      <a href="https://www.facebook.com/kioskradiobxl/" target="_blank"><img src="/images/social-facebook.svg" /></a>
      <a href="https://www.instagram.com/kiosk.radio/" target="_blank"><img src="/images/social-instagram.svg" /></a>
      <a href="https://twitter.com/kiosk_radio" target="_blank"><img src="/images/social-twitter.svg" /></a>
      <a href="https://mixcloud.com/KioskRadio" target="_blank"><img src="/images/social-mixcloud.svg" /></a>
      <a href="https://soundcloud.com/kioskradio" target="_blank"><img src="/images/social-soundcloud.svg" /></a>
      <a href="https://www.youtube.com/c/KioskRadio" target="_blank"><img src="/images/social-youtube.svg" /></a>
    </div>
  )

  renderNowPlaying = () => (
    <div className="header__now-playing">
      <NowPlaying />
    </div>
  )

  renderMobileNav = () => (
    <div className="header__mobile filled">
      <Link to="/programme">Programme</Link>
      <Link to="/insiders">Insiders</Link>
      <Link to="/outsiders">Outsiders</Link>
      <Link to="/kiosk-tv">Kiosk TV</Link>

      { this.renderSocial() }
    </div>
  )
}
